'use client';

import type { PropsWithChildren } from 'react';

interface Props {
  className?: string;
  onClick?: () => void;
  isButton?: boolean;
}

export const ButtonIcon = ({ children, className, onClick, isButton = true, ...props }: PropsWithChildren<Props>) => {
  if (isButton) {
    return (
      <button
        type="button"
        {...props}
        onClick={onClick}
        className={className}
      >
        {children}
      </button>
    );
  }

  if (!isButton) {
    return (
      <div
        {...props}
        onClick={onClick}
        className={className}
      >
        {children}
      </div>
    );
  }
};
